import capitalizeStringUtil from 'utils/string/capitalize'
import logUtil from 'utils/log'

/**
 * e.g. "Every 2 months - 10% off" => "Every 2 months (most common)"
 * e.g. "Every 3 months - 10% off" => "Every 3 months"
 * @param {object} props
 * @param {string} props.name
 * @param {boolean} props.shouldIgnoreMostCommon
 * @param {boolean} props.isShort
 * @returns {string}
 */
export default function getRecurrenceLabelFromPlanNameSubscriptionUtil (props) {
  const {
    shouldIgnoreMostCommon,
    isShort
  } = props

  logUtil('getRecurrenceLabelFromPlanNameSubscriptionUtil').debug('props=', props)
  const name = props.name || ''

  const regexSuffix = isShort ? '' : ' - $4% off'
  if (name.includes('1 month subscription')) {
    // 1 month subscription with 15% discount -> Every 1 month - 15% off
    return name.replace(/(\d+)\s(month)\ssubscription\s(with)\s(\d+)%\s(discount)/, `Every $1 $2${regexSuffix}`)
  } else if (name.includes('month subscription')) {
    // 3 month subscription with 15% discount -> Every 3 months - 15% off
    return name.replace(/(\d+)\s(month)\ssubscription\s(with)\s(\d+)%\s(discount)/, `Every $1 $2s${regexSuffix}`)
  }

  const nameWithoutDiscount = capitalizeStringUtil(
    name.split(' -')[0].toLowerCase()
  )

  if (
    nameWithoutDiscount.includes('2 months') &&
    !shouldIgnoreMostCommon
  ) {
    return nameWithoutDiscount + ' (most common)'
  }

  if (nameWithoutDiscount.includes('1 months')) {
    return nameWithoutDiscount.replace('months', 'month')
  }

  return nameWithoutDiscount
}
